<app-modal
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  (onShowing)="onShowingInternal()"
  (onHidden)="onHiddenInternal()"
  [closeOutsideClickEnabled]="false"
  modalTitle="Localização"
  width="25rem"
  height="35rem"
>
  <ng-template modalContent>
    <form class="form" [formGroup]="formGroup" (ngSubmit)="onSubmit($event)">
      <div class="fields-container">
        <div class="field-set">
          <label label>{{ "distrito" | fieldAlias : fields }}</label>

          <app-select-box
            formControlName="distrito"
            [items]="districtList"
            displayExpr="label"
            [searchEnabled]="true"
            [searchCaseSensitiveEnabled]="false"
            [showErrorEnabled]="false"
          ></app-select-box>
        </div>

        <div class="field-set">
          <label label>{{ "concelho" | fieldAlias : fields }}</label>

          <app-select-box
            formControlName="concelho"
            [items]="countyList"
            displayExpr="label"
            [searchEnabled]="true"
            [searchCaseSensitiveEnabled]="false"
            [showErrorEnabled]="false"
          ></app-select-box>
        </div>

        <div class="field-set">
          <label label>{{ "freguesia" | fieldAlias : fields }}</label>

          <app-select-box
            formControlName="freguesia"
            [items]="parishList"
            displayExpr="label"
            [searchEnabled]="true"
            [searchCaseSensitiveEnabled]="false"
            [showErrorEnabled]="false"
          ></app-select-box>
        </div>

        <div class="field-set">
          <label label>{{ "arruamento" | fieldAlias : fields }}</label>

          <app-input-box
            formControlName="arruamento"
            [showErrorEnabled]="false"
          ></app-input-box>
        </div>

        <div class="field-set">
          <label label>{{ "npolicia" | fieldAlias : fields }}</label>

          <app-input-box
            formControlName="npolicia"
            [showErrorEnabled]="false"
          ></app-input-box>
        </div>
      </div>

      <div class="actions-bottom">
        <app-button
          type="submit"
          buttonType="primary"
          styleType="contained"
          text="Aplicar"
          width="100%"
        ></app-button>

        <app-button
          buttonType="normal"
          styleType="contained"
          text="Limpar"
          (click)="onBtnClearClick()"
          width="100%"
        ></app-button>
      </div>
    </form>
  </ng-template>
</app-modal>
